import { render, staticRenderFns } from "./UserPurchases.vue?vue&type=template&id=3b830404"
import script from "./UserPurchases.vue?vue&type=script&lang=js"
export * from "./UserPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports